<template>
    <div class="main-empty">
      <van-empty
        class="custom-image"
        :image="image"
        :description="title"
      />
    </div>
</template>

<script>
    export default {
      name: "Empty",
      props: {
        title: {
          type: String,
          default: "空空如也..."
        },
        image: {
          type: String,
          default: "https://img.yzcdn.cn/vant/custom-empty-image.png"
        }
      }
    }
</script>

<style>
  .custom-image .van-empty__image {
    width: 90px;
    height: 90px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Empty.vue